import { mountUmamiTracker } from "@axqora/analytics";

export function installAnalytics() {
  mountUmamiTracker({
    enabled: import.meta.env.VITE_ANALYTICS_ENABLED,
    src: import.meta.env.VITE_UMAMI_SRC,
    websiteId: import.meta.env.VITE_UMAMI_WEBSITE_ID,
    domains: import.meta.env.VITE_UMAMI_DOMAINS || "moodshot.axqora.com"
  });
}
